import type { RootState } from "@src/store/rootState";
import { getConfiguration } from "@src/store/slices/organization/selectors/getConfiguration";

export const getCanCreateBundleOnsiteUpsell = (state: RootState): boolean =>
  !!getConfiguration<boolean>("create_bundle_onsite_upsell")(state);
